export default "__VITE_PUBLIC_ASSET__34d12d68__"